import TextAnswerService from 'services/task/subServices/questionTask/order/answer/subServices/TextAnswerService';

export default {
	'services.task.order.answer.text': {
		class: TextAnswerService,
	},
};
